// ---------------------------------------------------------------------------
// Keyboard shortcut display helpers — platform-aware modifier symbols.
// ---------------------------------------------------------------------------

const isMac =
  typeof navigator !== 'undefined' &&
  /Mac|iPod|iPhone|iPad/.test(navigator.platform)

/** Platform modifier key: ⌘ on macOS, Ctrl on others */
export const MOD = isMac ? '⌘' : 'Ctrl+'

/** Common shortcut labels for toolbar tooltips */
export const SHORTCUT = {
  undo: `${MOD}Z`,
  redo: isMac ? '⌘⇧Z' : 'Ctrl+Shift+Z',
  copy: `${MOD}C`,
  cut: `${MOD}X`,
  paste: `${MOD}V`,
  duplicate: `${MOD}D`,
  selectAll: `${MOD}A`,
  search: `${MOD}F`,
  preview: isMac ? '⌘⇧P' : 'Ctrl+Shift+P',
  delete: isMac ? '⌫' : 'Del',
  zoomToFit: `${MOD}0`,
  zoomTo100: `${MOD}1`,
  zoomIn: `${MOD}+`,
  zoomOut: `${MOD}-`,
  moveUp: `${MOD}↑`,
  moveDown: `${MOD}↓`,
  save: `${MOD}S`,
  open: `${MOD}O`,
} as const
